import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CampaignsPage from '../../pages/features/campaigns/CampaignsPage'

export default function CampaignsNav() {
    return (
        <Routes>
            <Route path="/" element={<CampaignsPage />} />

        </Routes>
    )
}
